import React, { Suspense, lazy } from "react";
import {
  Redirect,
  Route,
  Routes,
  BrowserRouter as Router,
} from "react-router-dom";
import Dashboard from "./modules/Dashboad";
import Map from "./modules/Map";


export default function BasePage() {

  return (
    <Router>
      <Routes>
        {/* <Route path="/atlas" component={Map} /> */}
        <Route path="/" element={<Map />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/atlas" element={<Map />} />
      </Routes>
    </Router>
  );
}
